let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dF2kg")).then(() => parcelRequire('aNw41'));